import { TODO } from '@b2b/types/core';
import angular, { IScope, ITimeoutService } from 'angular';

ReportsDatePickerController.$inject = ['$scope', '$timeout', 'HelpersService', 'UserPreferencesService'];

function ReportsDatePickerController(
  $scope: IScope & {
    initDate: TODO;
    formats: TODO;
    format: TODO;
    dt: TODO;
    minDate: TODO;
    reportsDatePicker: TODO;
  },
  $timeout: ITimeoutService,
  HelpersService: TODO,
  UserPreferencesService: TODO
) {
  const ctrl = {
    isOpen: false,

    isPreferenceLoaded: false,

    dateFormat: 'M!/d!/yyyy',

    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      showWeeks: false,
    },

    init: function () {
      this.today();
      $scope.initDate = new Date('2016-15-20');
      $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'yyyyMMdd', 'shortDate'];
      $scope.format = 'M!/d!/yyyy';
      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      $timeout(function () {
        ctrl.isPreferenceLoaded = true;
      }, 0);
    },

    today: function () {
      this.dt = new Date();
    },

    clear: function () {
      $scope.dt = null;
    },

    toggleMin: function () {
      $scope.minDate = $scope.minDate ? null : new Date();
    },

    open: function ($event) {
      $event.preventDefault();
      $event.stopPropagation();

      this.isOpen = true;
    },

    onDateFormatLoad: function (e, data) {
      ctrl.dateFormat = 'M!/d!/yyyy';
      ctrl.dateOptions = {
        ...ctrl.dateOptions,
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      };
    },
  };

  $scope.reportsDatePicker = ctrl;
  ctrl.init();
}

export const ReportsDatePickerControllerModule = angular
  .module('acme.view.application.reports.create.controllers.reports-date-picker', [])
  .controller('ReportsDatePickerController', ReportsDatePickerController).name;
